let flyOptions = {
  "duration":   500,
  "delay":      0,
  "direction":  "top"
};


$w.onReady(function () {

});



export function myRepeater_viewportEnter(event) {
	$w("#section6").scrollTo();
	$w("#vectorImage").show("fly",flyOptions);
}

export function box2_viewportEnter(event) {
$w("#section1").scrollTo();
$w("#vectorImage").hide("fly",flyOptions);
}